var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStepper = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 57,
    viewBox: "0 0 46 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-11.1%",
    y: "-29.9%",
    width: "148%",
    height: "154.9%",
    filterUnits: "objectBoundingBox",
    id: "8qkgai8w6a"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.478431373 0 0 0 0 0.556862745 0 0 0 0 0.588235294 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "db8umtpo2b",
    d: "m18 4.5 22.5 36h-45z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 20 24.5)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#8qkgai8w6a)",
    xlinkHref: "#db8umtpo2b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7A8E96",
    xlinkHref: "#db8umtpo2b"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStepper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-stepper.6c5933dec727275b0500c5b585339639.svg";